import {
  getFulfillmentWindowOperations,
  makeRequiresActivationConstraintOperations,
} from '@occc/feat-constraints';
import { LimitType, getLimitsInConstraintOperations } from '@occc/feat-limits';
import { GetConfigureFormOperations, Operation } from '@occc-app/offerHelpers/types';
import { getOfferCustomDataOperation } from '@occc-app/offerHelpers/operations/getOfferCustomDataOperation';
import { makeOfferUpdateOperation } from '@occc-app/offerHelpers/operations/makeOfferUpdateOperation';
import { isFieldDirty } from '@occc-app/offerHelpers/utils';

import { getOfferNameAndDescriptionUpdateOperations } from '@occc-app/routes/Offer/components/OfferConfigureForm/utils/offerNameAndDescriptionUpdateOperations';
import { getEarningMechanismOperations } from './earningMechanismOperations';

import { LoyaltyEventConfigureFormValues } from '../../../types';

export const getConfigureFormOperations: GetConfigureFormOperations<
  LoyaltyEventConfigureFormValues
> = (offerId, offer, values, dirtyFields) => {
  const earningMechanismOperations = getEarningMechanismOperations(offerId, values, dirtyFields);

  // using delete and create instead of update
  const activationConstraintOperations = makeRequiresActivationConstraintOperations(
    offerId,
    values.activation,
    dirtyFields,
    offer,
  );
  const activationLimitsOperations = getLimitsInConstraintOperations(
    offerId,
    values.activation,
    dirtyFields,
    LimitType.Activation,
  );
  const awardCountLimitsOperations = getLimitsInConstraintOperations(
    offerId,
    values.awardCount,
    dirtyFields,
    LimitType.AwardCount,
    { isTransactionFrequencyLimitSupported: false, offer },
  );
  const fulfillmentWindowOperations = getFulfillmentWindowOperations(
    offerId,
    values.fulfillmentWindow,
    dirtyFields,
  );

  const additionalOperations: Operation[] = [];
  const customDataOperation = getOfferCustomDataOperation({
    dirtyFields,
    values,
    offerId,
  });
  if (customDataOperation) {
    additionalOperations.push(customDataOperation);
  }
  if (
    isFieldDirty<LoyaltyEventConfigureFormValues>(dirtyFields, 'visibleForCommandCenterFulfillment')
  ) {
    additionalOperations.push(
      makeOfferUpdateOperation(offerId, {
        visibleForCommandCenterFulfillment: values.visibleForCommandCenterFulfillment,
      }),
    );
  }

  additionalOperations.push(
    ...getOfferNameAndDescriptionUpdateOperations(offerId, values, dirtyFields),
  );

  // ORDER is important
  // Can not mix awardCount limits and constraint
  return values.activation.isEnabled
    ? [
        ...earningMechanismOperations,
        ...fulfillmentWindowOperations,
        ...awardCountLimitsOperations,
        ...activationConstraintOperations,
        ...activationLimitsOperations,
        ...additionalOperations,
      ]
    : [
        ...earningMechanismOperations,
        ...fulfillmentWindowOperations,
        ...activationConstraintOperations,
        ...activationLimitsOperations,
        ...awardCountLimitsOperations,
        ...additionalOperations,
      ];
};
